import { IApplicationState } from 'setup/store'

export const selectGameList = (state: IApplicationState) => state.slots.data.gameList
export const selectFavouriteList = (state: IApplicationState) => state.slots.data.favorite
export const selectGameUrl = (state: IApplicationState) => state.slots.data.gameUrl
export const selectFreeSpinGameUrl = (state: IApplicationState) => state.slots.data.freeSpinGameUrl
export const selectBackUrl = (state: IApplicationState) => state.slots.data.backUrl
export const selectFreeSpinInfo = (state: IApplicationState) => state.slots.data.freeSpinInfo

export const selectSessionUrlComm = (state: IApplicationState) => state.slots.communications.getSessionUrl
export const selectFreeSpinSessionUrlComm = (state: IApplicationState) =>
  state.slots.communications.getFreeSpinSessionUrl

export const selectGameListLoading = (state: IApplicationState) =>
  Object.values(state.slots.communications.getGameList).some(t => t?.isLoading)

export const selectProducers = (state: IApplicationState) => state.slots.data.producers
export const selectProducersLoading = (state: IApplicationState) => state.slots.communications.getProducers

export const selectDigitainSlotToken = (state: IApplicationState) => state.slots.data.digitainSlotToken

export const selectTopSlots = (state: IApplicationState) => state.slots.data.externalGames.top.games

export const selectCategoriesGames = (state: IApplicationState) =>
  state.slots.data.externalGames.categories.categoriesData
export const selectTopSlotsLoading = (state: IApplicationState) => state.slots.data.externalGames.top.lastLoadDate
export const selectNewGames = (state: IApplicationState) => state.slots.data.externalGames.new.games
export const selectNewGamesLoading = (state: IApplicationState) => state.slots.data.externalGames.new.lastLoadDate
